<template>
  <div class="loading-spinner" v-if="loading">
    <div class="spinner-container">
      <div class="spinner">
        <div class="spinner-inner"></div>
      </div>
      <div class="loading-text">加载中...</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    loading: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
.loading-spinner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(10px);
}

.spinner-container {
  text-align: center;
  transform: scale(0.8);
  animation: appear 0.8s ease forwards;
}

.spinner {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  position: relative;
}

.spinner-inner {
  position: absolute;
  width: 100%;
  height: 100%;
  border: 4px solid transparent;
  border-top-color: #fdbb2d;
  border-radius: 50%;
  animation: spin 2s linear infinite;
}

.spinner-inner::before,
.spinner-inner::after {
  content: '';
  position: absolute;
  border: 4px solid transparent;
  border-radius: 50%;
}

.spinner-inner::before {
  top: -12px;
  left: -12px;
  right: -12px;
  bottom: -12px;
  border-top-color: #ff4b2b;
  animation: spin 3s linear infinite;
}

.spinner-inner::after {
  top: 6px;
  left: 6px;
  right: 6px;
  bottom: 6px;
  border-top-color: #ffffff;
  animation: spin 2.5s linear infinite;
}

.loading-text {
  color: #fdbb2d;
  font-size: 1.2em;
  font-weight: 500;
  text-shadow: 0 2px 10px rgba(0,0,0,0.3);
  animation: pulse 2s ease-in-out infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0% {
    opacity: 0.6;
    transform: scale(0.98);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0.6;
    transform: scale(0.98);
  }
}

@keyframes appear {
  from {
    opacity: 0;
    transform: scale(0.8) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
</style> 